import { MediaQueryBreakpoint } from "app/pages/sales-intelligence/types/styles";
import { useMediaQuery } from "react-responsive";

import { TOOLTIP_ITEMS_LIMIT, TOOLTIP_ITEMS_LIMIT_SMALL_SCREEN } from "../../constants/table-columns";

const useTooltipItemListCount = (): number => {
    const isSmallScreen = useMediaQuery({ screen: true, maxHeight: MediaQueryBreakpoint.MD });

    return isSmallScreen ? TOOLTIP_ITEMS_LIMIT_SMALL_SCREEN : TOOLTIP_ITEMS_LIMIT;
};

export default useTooltipItemListCount;
